import {CategoryType} from "globals/types/models.ts";
import TYPES from "config/store/types.ts";
import {Dispatch} from "redux";
import {tryAsyncFunc} from "globals/functions/async.ts";
import ajax from "config/ajax.ts";

import {EnumLangType, ToastType} from "globals/types/globals.ts";
import {getCurrentLang, selectLang} from "config/i18n.ts";

// Define a type for the slice state
interface State {
    categories: CategoryType[]
    toasts: ToastType[]
    isFetch: boolean,
    currentLang: EnumLangType
}

// Define the initial state using that type
const initialState: State = {
    isFetch: false,
    categories: [],
    toasts: [],
    currentLang: getCurrentLang()
}

export const globalReducer = (state = initialState, action: { payload: any, type: keyof typeof TYPES }): State => {
    switch (action.type) {
        case TYPES.GET_GLOBALS:
            return {
                ...state,
                isFetch: true,
                categories: action.payload.categories
            }
        case TYPES.SET_TOAST:
            return {
                ...state,
                toasts: action.payload
            }
        case TYPES.SET_LANG:
            return {
                ...state,
                currentLang: action.payload
            }
        default:
            return state
    }
}


export const globalActions = {
    setToast: (toast: ToastType | null) => async (dispatch: Dispatch) => {
        //let state = getState()
        dispatch({
            type: TYPES.SET_TOAST,
            payload: toast ? [toast] : []
        })
    },
    setLang: (lang: EnumLangType) => async (dispatch: Dispatch) => {
        selectLang(lang)
        dispatch({
            type: TYPES.SET_LANG,
            payload: getCurrentLang()
        })
    },
    getGlobals: () => async (dispatch: Dispatch) => {
        const [res, err] = await tryAsyncFunc(ajax.get('/public/globals'))

        if (err) {
          if (window.Sentry) {
            window.Sentry.captureException(err)
          }
            return
        }

        dispatch({
            type: TYPES.GET_GLOBALS,
            payload: {
                categories: res.data.categories
            }
        })
    }
}
